import { api } from "../utils/api";

const getFrequency = async (idTurmaDisc, dateFrom, dateTo) => {
  const res = await api.get("ClassDiaryV1/gridFrequency", {
    params: {
      idTurmaDisc,
      dateFrom,
      dateTo
    }
  });
  return res.data;
};

export default {
  getFrequency
};
